const company = {
  latitude: 31.49005,
  longitude: 74.396473,
  companyEmail: 'info@quhdock.com',
  umairEmail: 'umairqadeer.work@gmail.com',
  phoneNumber: 923124026251,
};

export default company;
